import { createReducer } from 'redux-create-reducer'
import type { PlaylistTag } from 'types/playlist'
import {
  PLAYLIST_TAGS_EDIT,
  PRELOAD_DATA_ON_LOGIN,
} from '@disco/constants/ActionTypes'
export type PlaylistTagsState = { [key in PlaylistTag['id']]?: PlaylistTag }
const initialState: PlaylistTagsState = {}
export const playlistTagsReducer = createReducer<PlaylistTagsState, any>(
  initialState,
  {
    [PRELOAD_DATA_ON_LOGIN](_state, action) {
      return action.entities.playlistTags ?? initialState
    },

    [PLAYLIST_TAGS_EDIT](state, action) {
      const updatedState = { ...state }

      if (action.id) {
        delete updatedState[action.id]
      }

      if (action.tag) {
        updatedState[action.tag.id] = action.tag
      }

      return updatedState
    },
  },
)
